import React from 'react';
import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router-dom';

import CountdownTimer from '../CountdownTimer';
import determineCartCount from '../../helpers/cart/determineCartCount';
import determineHeaderImage from '../Layout/Header/determineHeaderImage';
import siteInfoById from '../../constants/siteInfoById';

import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

const DetailHeader = (props) => {
	const { cartData, siteId } = props;

	const navigate = useNavigate();

	return (
		<Stack
			alignItems='center'
			component='header'
			className='filterbg'
			spacing={2}
			mb={1}
			py={2}
			sx={{
				px: 1,
				background: (theme) => theme.palette.common.white,
				position: 'fixed',
				top: 0,
				width: '100%',
				zIndex: 99
			}}
		>
			<Stack
				direction='row'
				justifyContent='space-between'
				sx={{
					width: { xs: '98%', sm: '96%', lg: '85%', xl: '65%' },
					'&:hover': {
						opacity: 0.8
					}
				}}
			>
				<Stack>
					<Link to='/' onClick={() => window.scrollTo({ top: 0 })}>
						<Box
							component='img'
							src={determineHeaderImage(siteId)}
							className='filter'
							alt={`${siteInfoById[siteId].name} Logo`}
							sx={{
								height: { xs: '39px', md: '60px' }
							}}
						/>
					</Link>
				</Stack>
				<Tooltip title={<Typography variant='body2'>Go To Cart</Typography>}>
					<IconButton
						className='filter'
						sx={{ mr: { xs: 0, sm: 0, md: 0, lg: 0, xl: '30px' }, color: 'common.black' }}
						onClick={() => {
							window.scrollTo({ top: 0 });
							navigate('/cart');
						}}
					>
						<Badge badgeContent={determineCartCount(cartData)} color='primary'>
							<ShoppingCartOutlinedIcon sx={{ fontSize: { xs: '28px', sm: '31px', md: '40px' } }} />
						</Badge>
					</IconButton>
				</Tooltip>
				<Stack
					sx={{
						position: 'absolute',
						top: {
							xs: '25px',
							md: '30px'
						},
						right: {
							xs: '75px',
							sm: '95px',
							md: '109px',
							lg: '200px',
							xl: '40px'
						}
					}}
				>
					<CountdownTimer />
				</Stack>
			</Stack>
		</Stack>
	);
};

DetailHeader.propTypes = {
	cartData: PropTypes.array,
	siteId: PropTypes.number
};

export default DetailHeader;
